<template>
  <section-wrapper background="gradient-blue" padding="large">
    <section-header
      title="2026 оны Боловсролын салбарын шилдэг олон улсын арга xэмжээ, үзэсгэлэн xудалдаа"
      align="center"
      :dark="true"
    />

    <!-- Agenda Carousel -->
    <div class="agenda-carousel">
      <v-row v-if="agendaSessions.length > 0">
        <v-col
          v-for="(session, index) in agendaSessions"
          :key="index"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card
            class="session-card"
            elevation="4"
            @click="openEventDialog(session)"
          >
            <div class="card-header">
              <div class="badges-row">
                <div class="country-badge" v-if="session.country">
                  <span class="country-flag">🌍</span>
                  <span class="country-name">{{ session.country }}</span>
                </div>
                <div
                  v-if="session.shortDescription"
                  class="session-tag"
                  style="background-color: #ed7835"
                >
                  {{ session.shortDescription }}
                </div>
              </div>
            </div>

            <v-card-text class="session-content">
              <h3 class="session-topic">{{ session.name }}</h3>

              <div class="event-details">
                <div v-if="session.date" class="detail-item">
                  <span class="detail-icon">📅</span>
                  <span
                    class="detail-text"
                    style="font-weight: bold; color: #fb2bff"
                    >{{ session.date }}</span
                  >
                </div>
                <div v-if="session.location" class="detail-item">
                  <span class="detail-icon">📍</span>
                  <span class="detail-text">{{ session.location }}</span>
                </div>
              </div>

              <p v-if="session.description" class="session-description">
                {{ session.description.substring(0, 100)
                }}{{ session.description.length > 100 ? "..." : "" }}
              </p>

              <v-btn
                text
                color="#1C2C42"
                class="details-btn"
                @click="openEventDialog(session)"
              >
                Дэлгэрэнгүй үзэх
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
              <p v-if="session.ticket" style="color: #ED7835">
                Эрт заxиалвал тийзийн үнэ ~{{ session.ticket }} USD
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div class="cta-section">
      <!-- <gradient-button
        @click="$router.push('/agenda')"
        variant="bordered-white"
        size="large"
      >
        Дэлгэрэнгүй мэдээллийг цаг бүрд танилцуулна
      </gradient-button> -->
    </div>

    <!-- Event Details Modal -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card v-if="selectedEvent">
        <v-card-title class="dialog-header">
          <div class="dialog-badges">
            <div class="country-badge" v-if="selectedEvent.country">
              <span class="country-flag">🌍</span>
              <span class="country-name">{{ selectedEvent.country }}</span>
            </div>
            <div
              v-if="selectedEvent.shortDescription"
              class="session-tag"
              style="background-color: #ed7835"
            >
              {{ selectedEvent.shortDescription }}
            </div>
          </div>
          <v-btn icon @click="dialog = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <h2 class="dialog-title">{{ selectedEvent.name }}</h2>

          <div class="dialog-details">
            <div v-if="selectedEvent.date" class="dialog-detail-item">
              <span class="detail-icon">📅</span>
              <div>
                <div class="detail-label">Огноо</div>
                <div class="detail-value">{{ selectedEvent.date }}</div>
              </div>
            </div>
            <div v-if="selectedEvent.location" class="dialog-detail-item">
              <span class="detail-icon">📍</span>
              <div>
                <div class="detail-label">Байршил</div>
                <div class="detail-value">{{ selectedEvent.location }}</div>
              </div>
            </div>
          </div>

          <div v-if="selectedEvent.description" class="dialog-description">
            <h3 class="description-title">Дэлгэрэнгүй мэдээлэл</h3>
            <p>{{ selectedEvent.description }}</p>
          </div>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn color="#ED7835" text @click="dialog = false"> Хаах </v-btn>
          <v-btn
            color="#ED7835"
            depressed
            dark
            @click="$router.push('/form-fill')"
          >
            Бүртгүүлэх
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section-wrapper>
</template>

<script>
import SectionWrapper from "./SectionWrapper.vue";
import SectionHeader from "./SectionHeader.vue";
// import GradientButton from './GradientButton.vue'
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  addDoc,
} from "firebase/firestore";

export default {
  name: "AgendaHighlights",
  components: {
    SectionWrapper,
    SectionHeader,
    // GradientButton
  },
  data() {
    return {
      agendaSessions: [],
      dialog: false,
      selectedEvent: null,
    };
  },
  mounted() {
    this.fetchEvents();
    // this.copyDocs();
  },
  methods: {
    copyDocs() {
      var arr = [
        {
          name: "Edtech Korea",
          shortDescription: "Экспо",
          createdAt: new Date(),
          date: "1-р сарын 17-24",
          order: 1,
          location: "Сөүл, Өмнөд Солонгос",
          description:
            'Education Korea 2026 нь Азийн боловсролын технологи, контентын хамгийн том үзэсгэлэн бөгөөд 2026 оны 1-р сарын 21-нээс 23-ны өдрүүдэд Сөүл дэх COEX-т болно. Энэ нь "Ирээдүй бол Боловсрол!" уриан дор ирээдүйн боловсролын чиг хандлагыг харуулдаг. Тус арга хэмжээ нь EdTech, хиймэл оюун ухаан (AI), Метаверс, STEAM шийдлүүдэд онцгой ач холбогдол өгч, боловсролын салбарын мэргэжилтнүүд болон олон нийтэд шинэ технологи, бизнесийн боломжуудыг судлах чухал талбар болж байна.',
        },
        {
          location: "Орландо, АНУ",
          description:
            "FETC (Future of Education Technology Conference) 2026 нь Боловсролын Технологийн Ирээдүйн Чуулган бөгөөд 2026 оны 1-р сарын 11-нээс 14-ний өдрүүдэд АНУ-ын Орландо хотноо болно. Энэхүү тэргүүлэх арга хэмжээ нь К-12 (Бага, дунд, ахлах) боловсролд технологийн хэрэглээг нэвтрүүлэхэд чиглэдэг. Хиймэл оюун ухаан (AI), кибер аюулгүй байдал, дижитал тэгш байдал зэрэг сэдвүүдийг хөндөж, багш, удирдлагуудад сургалтын шинэ шийдлүүдийг олоход тусалдаг.",
          order: 2,
          shortDescription: "Экспо + Конференц",
          createdAt: new Date(),
          date: "1-р сарын 11-14",
          name: "FETC – Ирээдүйн Боловсролын Технологийн Конференц",
        },
        {
          location: "Лондон, Англи",
          shortDescription: "Экспо",
          description:
            "Bett UK нь боловсролын технологийн дэлхийн тэргүүлэгч арга хэмжээ бөгөөд 2026 оны 1-р сард (урьдчилсан) Лондон дахь ExCeL төвд болно. Энэ нь боловсрол судлаачид, технологийн ханган нийлүүлэгчид, бодлого боловсруулагчдыг нэгтгэдэг. Үзэсгэлэн нь AI, VR/AR, Дижитал ур чадвар, Боловсролын дэд бүтэц зэрэг ирээдүйн сургалтын шийдлүүдэд анхаарлаа хандуулж, боловсролын салбарт санаачилга, хамтын ажиллагааг дэмжих чухал талбар болдог.",
          createdAt: new Date(),
          name: "Bett (UK)",
          date: "1-р сарын 21-23",
          order: 3,
        },
        {
          name: "Global Education & Training Exhibition 2026 (GETEX)",
          location: "Дубай, АНЭ",
          date: "4-р сарын 15-17",
          createdAt: new Date(),
          shortDescription: "Том хэмжээний технологийн экспо",
          order: 4,
          description:
            "GETEX 2026 нь 2026 оны 4-р сарын 15-наас 17-ны өдрүүдэд Дубай хотноо, Дубайн Олон Улсын Хурал, Үзэсгэлэнгийн Төвд (Dubai International Convention & Exhibition Centre) болох Боловсрол, Сургалтын Дэлхийн Үзэсгэлэн (Global Education & Training Exhibition) юм. Энэ нь Ойрх Дорнод болон Хойд Африкийн (MENA) бүс нутагт оюутан элсүүлэх тэргүүлэх арга хэмжээ бөгөөд суралцагчид, эцэг эхчүүд, мэргэжилтнүүдэд боловсролын хөтөлбөрүүдийг судлах, карьерын зөвлөгөө авах, дотоодын болон олон улсын боловсролын байгууллагуудтай холбогдох боломжийг олгодог талбар юм. Тус үзэсгэлэнд 35,000 гаруй оюутан оролцоно гэсэн хүлээлттэй байгаа нь дээд боловсрол эсвэл мэргэжлийн хөгжлийн боломж хайж буй хэн бүхэнд чухал ач холбогдолтой арга хэмжээ болох юм.",
        },
        {
          order: 5,
          description:
            "EDIX (Японы Боловсролын IT Шийдлийн Экспо) нь тус улсын боловсролын салбарт зориулсан хамгийн том IT үзэсгэлэн юм. Энэ нь 2026 онд Токио (5-р сар) болон Осака (11-р сал) хотуудад зохион байгуулагдах төлөвтэй байна. EDIX нь сургуулийн удирдлагууд болон багш нарт LMS, цахим хичээл, сургуулийн удирдлагын систем, ухаалаг төхөөрөмж зэрэг боловсролын шинэ технологи, шийдлүүдийг танилцуулж (VR/AR, дижитал сурах бичиг), нэвтрүүлэхэд тусалдаг. Ази дахь хамгийн том EdTech үзэсгэлэн.",
          createdAt: new Date(),
          date: "5-р сарын 13-15",
          name: "EDIX (Японы Боловсролын IT Шийдлийн Экспо)",
          shortDescription: "Экспо",
          location: "Токио, Япон",
        },
        {
          description:
            "EDUtech Australia 2026 нь 2026 оны 6-р сарын 3–4-ний өдрүүдэд Сиднейн ICC төвд болох Австрали болон Ази, Номхон далайн бүс нутгийн боловсролын технологийн гол хурал юм. Энэхүү арга хэмжээ нь К-12 болон дээд боловсролын удирдагчдыг нэгтгэж, AI, AR/VR, Дижитал сургалтын орчин зэрэгт анхаарлаа хандуулдаг. Энэ нь боловсролын дижитал шилжилт, бүтээлч байдлыг хөгжүүлэх чухал талбар юм.",
          createdAt: new Date(),
          shortDescription: "Экспо",
          date: "6-р сарын 3–4",
          name: "EDUtech",
          order: 6,
          location: "Сидней",
        },
        {
          location: "Сингапур",
          name: "EduTech Asia",
          order: 7,
          shortDescription: "Экспо",
          createdAt: new Date(),
          description:
            "EDUtech Asia 2025 нь боловсролын инновацийн 10 жилийн ойг тэмдэглэж буй шилдэг арга хэмжээ бөгөөд боловсролын ажилтнууд болон EdTech нийлүүлэгчдийн хоорондын харилцан яриа, хамтын ажиллагаанд төвлөрдөг. Энэхүү арга хэмжээнд урам зориг өгөх илтгэлүүд, практик сургалт, хамгийн сүүлийн үеийн боловсролын технологиудыг танилцуулсан олон брэндийн үзэсгэлэн багтана. Мөн энэ арга хэмжээ нь гарааны бизнесүүдийн оролцоог дэмжиж, боловсролын салбар дахь шилдэг амжилтуудыг хэд хэдэн төрөлд үнэлэн шагнадаг.",
          date: "11-р сарын 5–6",
        },
        {
          shortDescription: "Экспо",
          date: "12-р сарын 8-11",
          description:
            "GITEX GLOBAL 2026 нь дэлхийн хамгийн том технологи, хиймэл оюун ухаан (AI), стартапын арга хэмжээ бөгөөд 2026 оны 12-р сарын 7-11-ний өдрүүдэд Дубайн Экспо Ситид болно. Энэхүү мега-экспо нь AI, Квант Компьютер, Web 3.0, болон Стартапууд зэрэг ирээдүйн технологиудад голлон анхаарна. Энэ нь дэлхийн хэмжээний гүйцэтгэх захирлууд, хөрөнгө оруулагчид, болон технологийн шинийг санаачлагчдыг холбох чухал талбар юм.",
          location: "Дубай, АНЭ",
          order: 8,
          name: "GITEX GLOBAL 2026",
          createdAt: new Date(),
        },
      ];

      arr.forEach(async (item) => {
        try {
          await addDoc(collection(db, "events"), item);
          console.log("Document successfully written!");
        } catch (e) {
          console.error("Error adding document: ", e);
        }
      });
    },
    openEventDialog(event) {
      this.selectedEvent = event;
      this.dialog = true;
    },
    async fetchEvents() {
      try {
        const eventsQuery = query(
          collection(db, "events"),
          orderBy("order", "asc")
        );
        const querySnapshot = await getDocs(eventsQuery);
        this.agendaSessions = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ref: doc.ref,
          ...doc.data(),
        }));
        console.log(this.agendaSessions);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    },
  },
};
</script>

<style scoped>
.agenda-carousel {
  margin-bottom: 60px;
}

.session-card {
  height: 100%;
  border-radius: 12px !important;
  overflow: hidden;
  position: relative;
  background: rgba(255, 255, 255, 0.95) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.session-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(124, 58, 237, 0.3) !important;
}

@media (max-width: 600px) {
  .session-card:hover {
    transform: translateY(-4px);
  }
}

.card-header {
  padding: 16px 20px 0;
}

.badges-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.session-tag {
  background: #7c3aed;
  color: white;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.session-content {
  padding: 20px 24px 24px !important;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.country-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
}

.country-flag {
  font-size: 14px;
}

.country-name {
  letter-spacing: 0.3px;
}

.session-topic {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.3;
  margin: 0;
  flex-grow: 1;
}

.event-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #555;
}

.detail-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.detail-text {
  font-weight: 500;
  line-height: 1.4;
}

.session-description {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin: 0;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.details-btn {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.3px;
  margin-top: auto;
  padding: 0 !important;
  justify-content: flex-start;
}

/* Dialog Styles */
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 24px 16px !important;
  border-bottom: 1px solid #f0f0f0;
}

.dialog-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.close-btn {
  margin-left: auto;
}

.dialog-content {
  padding: 32px 24px !important;
}

.dialog-title {
  font-size: 28px;
  font-weight: 700;
  color: #26365d;
  line-height: 1.3;
  margin-bottom: 24px;
}

.dialog-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.dialog-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.dialog-detail-item .detail-icon {
  font-size: 24px;
  margin-top: 4px;
}

.detail-label {
  font-size: 12px;
  color: #999;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 16px;
  color: #ed7835;
  font-weight: 600;
}

.dialog-description {
  margin-top: 24px;
}

.description-title {
  font-size: 18px;
  font-weight: 700;
  color: #26365d;
  margin-bottom: 16px;
}

.dialog-description p {
  font-size: 15px;
  color: #555;
  line-height: 1.8;
  margin: 0;
}

.dialog-actions {
  padding: 16px 24px !important;
  border-top: 1px solid #f0f0f0;
}

.cta-section {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

/* Responsive Design */
@media (max-width: 960px) {
  .agenda-carousel {
    margin-bottom: 50px;
  }

  .session-content {
    min-height: 240px;
  }

  .cta-section {
    margin-top: 30px;
  }
}

@media (max-width: 600px) {
  .agenda-carousel {
    margin-bottom: 40px;
  }

  .session-topic {
    font-size: 18px;
    line-height: 1.4;
  }

  .session-content {
    padding: 16px 18px 18px !important;
    min-height: auto;
  }

  .card-header {
    padding: 12px 16px 0;
  }

  .session-tag {
    font-size: 10px;
    padding: 5px 12px;
  }

  .country-badge {
    font-size: 11px;
    padding: 5px 12px;
  }

  .detail-item {
    font-size: 12px;
  }

  .session-description {
    font-size: 12px;
    line-height: 1.5;
  }

  .dialog-header {
    padding: 20px 20px 12px !important;
  }

  .dialog-content {
    padding: 24px 20px !important;
  }

  .dialog-title {
    font-size: 22px;
  }

  .dialog-details {
    padding: 16px;
    gap: 16px;
  }

  .dialog-actions {
    padding: 12px 20px !important;
  }
}
</style>
